import { INTEGRATION_CODE } from "../../../../../models/IntegrationsTypes";
import { makeAutoObservable } from "mobx";
import { ICredentialsStore } from "../integration-store";
import IntegratorOAuthHandler from "./oauth-handler/integrator-oauth-handler";

class RiseAiOAuthCredentialsStore implements ICredentialsStore {
    private _oauthHandler = new IntegratorOAuthHandler(INTEGRATION_CODE.RISE_AI_OAUTH);

    constructor() {
        makeAutoObservable(this);
    }

    getCredentials() {
        return this._oauthHandler.getCredentials();
    }
}

export default RiseAiOAuthCredentialsStore;
